export enum CourseProgressEnum {
	NotStarted = "NotStarted",
	InProgress = "InProgress",
	Paused = "Paused",
	Success = "Success",
	Failed = "Failed",
}
